<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
                <i class="el-icon-s-home"></i>首页
            </el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>扶持号管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input
                    v-model="queryField.user_id"
                    size="small"
                    placeholder="用户ID"
                ></el-input>
                <el-button
                    type="primary"
                    @click="loadData(1)"
                    icon="el-icon-search"
                    size="small"
                >查询</el-button>
                <el-button
                    type="primary"
                    @click="reset"
                    size="small"
                >重置</el-button>
                <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-plus"
                    @click="addSupport">
                    添加扶持号
                </el-button>
            </el-row>
            <el-table
                class="cps-table-data"
                :data="tableData"
                size="small"
                border
                :height="height"
                style="width: 100%"
            >
                <el-table-column 
                    prop="user_id" 
                    label="用户id" 
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    label="用户名"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="nick_name"
                    label="昵称"
                    width="120">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template v-slot="scope">
                        <el-button type="text" @click="addLimit(0,scope.row.user_id)">添加设备</el-button>
                        <el-button type="text" @click="addLimit(1,scope.row.user_id)">添加ip</el-button>
                        <el-button type="text" @click="toGetLimit(scope.row.user_id)">查看限制</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="fixed-pagination"
                @current-change="loadData"
                background
                :page-size="15"
                :current-page="currentIndex"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="35%">
            <el-table :data="userLimitData">
                <el-table-column property="user_id" label="用户id" width="120"></el-table-column>
                <el-table-column property="limit_type" :formatter="formatterLimitType" label="限制类型" width="120"></el-table-column>
                <el-table-column property="limit_value" label="设备号/ip"></el-table-column>
                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-button type="text" @click="delDeviceLimit(scope.row.limit_id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import {addDevice, addSupport, delDeviceLimit, getDeviceLimit, querySupport} from "@/api/request";

export default {
    name: "supportlist",
    data(){
        return {
            queryField: {
                user_id: ''
            },
            tableData: [],
            total: 0,
            currentIndex:1,
            height: window.innerHeight - 250,
            dialogVisible: false,
            userLimit: {
                userId: '',
                type: '',
                value: ''
            },
            userLimitData: [],
            userId: ''
        }
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(index){
            let params = {
                pageNo: index,
                pageSize: 15,
                params: this.queryField
            }
            querySupport(params).then(res => {
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.currentIndex = index;
            })
        },
        addSupport(){
            this.$prompt('','添加扶持号',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入用户id'
            }).then(({value}) => {
                addSupport(value).then(res => {
                    if(res.data.success){
                        this.$message.success("扶持号添加成功");
                        this.loadData(1);
                    }else {
                        this.$message.error(res.data.error.message);
                    }
                })
            })
        },
        addLimit(type,userId){
            this.userLimit.userId = userId;
            this.userLimit.type = type;
            
            this.$prompt('','添加账号限制',{
                confirmButtonText: '保存',
            }).then(({value}) => {
                this.userLimit.value = value;
                addDevice(this.userLimit).then(res => {
                    if(res.data.success){
                        this.$message.success("添加成功");
                    }else {
                        this.$message.error(res.data.error.message);
                    }
                })
            })
        },
        toGetLimit(userId){
            this.dialogVisible = true;
            this.userId = userId;
            this.getLimit();
        },
        getLimit(){
            getDeviceLimit(this.userId).then(res => {
                this.userLimitData = res.data.data;
            })
        },
        delDeviceLimit(limitId){
            delDeviceLimit(limitId).then(res => {
                if(res.data.success){
                    this.$message.success("操作成功");
                    this.getLimit();
                }else {
                    this.$message.error(res.data.error.message);
                }
            })
        },
        formatterLimitType(row, column, cellValue){
          let rep = '';
          if(cellValue === 0){
              rep = '设备限制';
          }else if(cellValue === 1){
              rep = 'ip限制'
          }
          return rep;
        },
        reset(){
            this.queryField = {
                user_id: ''
            }
            this.loadData(1);
        }
    }
}
</script>

<style scoped>

</style>